import Style from 'ol/style/Style';
import CircleStyle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';


export const getPolygonStyle = (fill, stroke, strokeWidth) =>
{
    return new Style({
        fill: new Fill({ color: fill }),
        stroke: new Stroke({ color: stroke, width: strokeWidth }),
    });
};

export const getCircleStyle = (radius, fillColor, strokeColor='black', strokeWidth=1) =>
{
    return new CircleStyle({
        radius,
        fill: new Fill({color: fillColor}),
        stroke: new Stroke({color: strokeColor, width: strokeWidth }),
    });
};

export const getPointStyle = (fillColor, strokeColor, strokeWidth) =>
{
    return new Style({
        image: getCircleStyle(5, fillColor, strokeColor, strokeWidth),
    });
};